import axios from 'axios';
import { CartCount } from './cart-count';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class CartAdd {
    constructor(element, options) {
        const defaults = {
            initAttr: 'data-cart-add',
            onSubmit: null,
            loader: null,
            minicartActiveClass: 'minicart__overlay--is-active',
            minicartActiveFromProductClass: 'minicart__overlay--added'
        };
        this.settings = { ...defaults, ...options };
        this.$cart = document.querySelector('[data-minicart="root"]');
        this.$addToCart = element;
        this.$cartContent = document.querySelector('[data-cart="content"]');
        this.initialize();
    }

    initialize() {
        this.initForm();
    }

    initForm() {
        this.$addToCartButton = this.$addToCart.querySelector('[data-cart-add="button"]');

        if (this.$addToCartButton) {
            this.$addToCartButton.addEventListener('click', (e) => {
                const formMethod = this.$addToCart.getAttribute('method');
                const formAction = this.$addToCart.getAttribute('action');
                const formData = new FormData(this.$addToCart);

                axios({
                    method: formMethod,
                    url: formAction,
                    data: formData
                })
                    .then((response) => {
                        if (response.data.action && response.data.content) {
                            if (response.data.action === 'render') {
                                const div = document.createElement('div');
                                div.innerHTML = response.data.content;

                                if (this.$cartContent) {
                                    const responseContent = div.querySelector('[data-cart="content"]');
                                    this.$cartContent.innerHTML = responseContent.innerHTML;

                                    this.$minicartItems = this.$cartContent.querySelector('[data-minicart-count]');
                                    this.$minicartItemsCount = this.$minicartItems.getAttribute('data-minicart-count');

                                    const cartCount = new CartCount();
                                    cartCount.updateCountIndicator(this.$minicartItemsCount);

                                    if (window.innerWidth < 1024) {
                                        disableBodyScroll(this.$cart);
                                    }

                                    this.$cart.classList.add(this.settings.minicartActiveClass, this.settings.minicartActiveFromProductClass);
                                    this.showMinicartOverlay();
                                }

                                if (typeof this.settings.onSubmit === 'function') {
                                    this.settings.onSubmit(this.$addToCart);
                                    this.settings.onSubmit(this.$cartContent);
                                }
                            }

                            if (response.data.action === 'productNotAllowed') {
                                const url = new URL(window.location);
                                window.location.href = url.toString();
                            }
                        }
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });

                e.preventDefault();
            });
        }
    }

    showMinicartOverlay() {
        let skipTimeout = false;

        this.$cart.addEventListener('mouseenter', () => {
            disableBodyScroll(this.$cart);
            skipTimeout = true;
        });

        this.$cart.addEventListener('mouseleave', () => {
            this.$cart.classList.remove('minicart__overlay--is-active', 'minicart__overlay--added');
            clearAllBodyScrollLocks();
        });

        setTimeout(() => {
            this.$addToCartButton.classList.remove('product-item__add-to-cart--is-added');

            if (!skipTimeout) {
                clearAllBodyScrollLocks();
                this.$cart.classList.remove('minicart__overlay--is-active', 'minicart__overlay--added');
            }
        }, 2000);
    }
}

export { CartAdd };
